export const isInternalURL = (to: string) => !new RegExp('^(http|https)://', 'i')?.test(to);
